import { viewSpecs, responsiveDir, updateActiveSpec, activeSpec, systemLog, unlockedSpecs } from "../storage.js";
import { prepare } from "../direct.js";
import { get } from "svelte/store";
import { setSpecTree } from "../tree.js";
import * as d3 from "d3";

export let FirstMenuArtboard = {
  name: 'artboard',
  title: 'Manage artboards',
  shortcut: 'a'
}

export const device_ppi = 227;
export let deviceTypes = {
  "Desktop-Landscape": { name: "Desktop-Landscape", type: "desktop", orient: "landscape", a_width: 1000, a_height: 600, width: 1440, height: 900, ppi: 227, icon: "laptop" }, // model: macbook pro 13"; standard ppi;
  "Desktop-Square": { name: "Desktop-Square", type: "desktop", orient: "sqaure", a_width: 1000, a_height: 600, width: 1440, height: 900, ppi: 227, icon: "slash-square" },
  "Desktop-Portrait": { name: "Desktop-Portrait", type: "desktop", orient: "portrait", a_width: 1000, a_height: 600, width: 1440, height: 900, ppi: 227, icon: "file" },

  "Phone-Portrait": { name: "Phone-Portrait", type: "phone", orient: "portrait", a_width: 380, a_height: 400, width: 390, height: 844, ppi: 460, icon: "phone" },
  "Phone-Square": { name: "Phone-Square", type: "phone", orient: "sqaure", a_width: 380, a_height: 380, width: 390, height: 844, ppi: 460, icon: "app" },
  "Phone-Landscape": { name: "Phone-Landscape", type: "phone", orient: "landscape", a_width: 840, a_height: 350, width: 844, height: 390, ppi: 460, icon: "phone-landscape" }, // model: iphone 13

  "Tablet-Portrait": { name: "Tablet-Portrait", type: "tablet", orient: "portrait", a_width: 800, a_height: 500, width: 810, height: 1080, ppi: 264, icon: "tablet" },
  "Tablet-Landscape": { name: "Tablet-Landscape", type: "tablet", orient: "landscape", a_width: 750, a_height: 750, width: 1080, height: 810, ppi: 264, icon: "tablet-landscape" }, // model: ipad air 10.9"
  "Tablet-Square": { name: "Tablet-Square", type: "tablet", orient: "sqaure", a_width: 1000, a_height: 600, width: 1080, height: 810, ppi: 264, icon: "square" },

  "Thumbnail": { name: "Thumbnail-Square", type: "thumbnail", orient: "square", a_width: 200, a_height: 200, width: 200, height: 200, ppi: 227, icon: "app" }, // For Desktop

  "Watch-Square": { name: "Watch-Square", type: "watch", orient: "square", a_width: 160, a_height: 160, width: 162, height: 162, ppi: 326, icon: "smartwatch" }, // model: apple watch series 7 40mm
  "Watch-Radial": { name: "Watch-Radial", type: "watch", orient: "radial", a_width: 180, a_height: 180, width: 180, height: 180, ppi: 364, icon: "watch" }, // model: galaxy watch 41mm

  "Printing": { name: "Printing-Portrait", type: "printing", orient: "portrait", a_width: 800, a_height: 500, width: 816, height: 1054, ppi: 227, icon: "file" }, // Letter
};

function checkViewable(container, artboard) {
  let containerBbox = container.getBoundingClientRect();
  let artboardBbox = artboard.getBoundingClientRect();
  let y = artboard?.offsetTop - container?.scrollTop;
  let y2 = y + artboardBbox.height;
  let x = artboard?.offsetLeft - container?.scrollLeft;
  let x2 = x + artboardBbox.width;
  let horizontal = x > 0 && x2 < containerBbox.width;
  let vertical = y > 0 && y2 < containerBbox.height
  let both = horizontal && vertical
  return { horizontal, vertical, both }
}

export function moveToArtboard(uid) {
  // todo: update this pattern (when it's viewable, don't update)
  let container = document.querySelector("#view-column");
  let artboard = document.querySelector(`#dupo-view-${uid}`);
  if (container && artboard) {
    let viewable = checkViewable(container, artboard);
    if (viewable.both) return;
    if (!viewable.vertical) container.scrollTop = (artboard.offsetTop - 62);
    if (!viewable.horizontal) container.scrollLeft = (artboard.offsetLeft - 40);
  }
}
export function afterDeleteArtboard(uid) {
  let is_first = false;
  viewSpecs.update((specs) => {
    specs.forEach((s) => {
      if (s.uid === uid && s.is_first) is_first = true;
    });
    let new_specs = specs.filter((s) => s.uid !== uid);
    let fmax = -1,
      fmin = 999999999,
      tmax = -1,
      tmin = 999999999,
      new_first_uid_large,
      new_first_uid_small,
      largest_target,
      smallest_target;
    // loop 1 : stats
    new_specs.forEach((s) => {
      // to change the first view
      if (fmax < s.artboard.device_width) {
        fmax = s.artboard.device_width;
        new_first_uid_large = s.uid;
      }
      if (fmin > s.artboard.device_width) {
        fmin = s.artboard.device_width;
        new_first_uid_small = s.uid;
      }
      // to change source view
      if (s.source === uid && tmax < s.artboard.device_width) {
        tmax = s.artboard.device_width;
        largest_target = s.uid;
      }
      if (s.source === uid && tmin > s.artboard.device_width) {
        tmax = s.artboard.device_width;
        smallest_target = s.uid;
      }
    });
    // loop 2: assign
    new_specs.forEach((s) => {
      // change the first view
      if (
        is_first &&
        get(responsiveDir) === "large" &&
        new_first_uid_large === s.uid
      ) {
        s.first = true;
      } else if (
        is_first &&
        get(responsiveDir) === "small" &&
        new_first_uid_small === s.uid
      ) {
        s.first = true;
      }
      // change source view
      if (get(responsiveDir) === "large" && uid === s.source) {
        s.source = largest_target;
      } else if (get(responsiveDir) === "small" && uid === s.source) {
        s.source = smallest_target;
      } else if (uid === s.source) {
        s.source = new_specs[0].uid;
      }
    });
    return new_specs;
  });
}

export function showSpinnerOnArtboard(uid) {
  // document.querySelector("#artboard-" + uid).classList.remove("new");
  // document.querySelector("#artboard-" + uid).classList.add("new");
  let dom = document.querySelector("#artboard-" + uid);
  // dom.style.animation = "";
  // dom.style.animation = "show-new 0.6s cubic-bezier(0, 0, 0.3, 1.0) 0.6s";
  dom.animate([
    // keyframes
    { opacity: 0 },
    { opacity: 1 }
  ], {
    // timing options
    duration: 600,
    iterations: 1,
    easing: "cubic-bezier(0, 0, 0.3, 1.0)",
  });
}
export function hideSpinnerOnArtboard(uid) {
}

export function afterRender(spec, isHypo) {
  prepare("#view-" + spec.uid);
  let ruler_top = document.querySelector(
    "#dupo-view-" + spec.uid + " .ruler-top"
  );
  let ruler_left = document.querySelector(
    "#dupo-view-" + spec.uid + " .ruler-left"
  );
  let artboard = document.querySelector("#artboard-" + spec.uid);
  if (ruler_top) {
    ruler_top.style.width = `calc(${Math.min(
      spec.artboard.device_width,
      artboard.offsetWidth - 32
    )}px + 1rem)`;
    let ruler_mark = ruler_top.querySelector(".mark_right_limit");
    if (ruler_mark) {
      ruler_mark.style.left = spec.artboard.device_width - 100 + "px";
    }
  }
  if (ruler_left) {
    ruler_left.style.height = `calc(${Math.min(
      spec.artboard.device_height,
      artboard.offsetHeight - 32
    )}px + 1rem)`;
    let ruler_mark = ruler_left.querySelector(".mark_bottom_limit");
    if (ruler_mark) {
      ruler_mark.style.top = spec.artboard.device_height + "px";
    }
  }
  // to prevent rapid layout changes;
  artboard.style.width = `calc(${Math.max(...Array.from(artboard.childNodes).map(d => d.offsetWidth))}px 2rem)`;
  artboard.style.height = `calc(${Array.from(artboard.childNodes).reduce((a, c) => a + c.offsetHeight, 0)}px 2rem)`;
  // update tree
  if (!isHypo) {
    setSpecTree(spec);
  }
  // status bar sizing
  let status_bar_width = spec.fronto.layout.width * 0.5 || 120;
  document.querySelector(`#dupo-view-${spec.uid} .dupo-view-status .controls`).style.maxWidth = Math.round(status_bar_width) + 'px';
  document.querySelector(`#dupo-view-${spec.uid} .dupo-view-status .status`).style.maxWidth = Math.round(status_bar_width) + 'px';
}

export function markSourceView(buid, uid) {
  let sourceBoard = document.querySelector("#artboard-" + uid);
  let button = document.querySelector("#rec-button-" + buid);
  let sourceBbox = sourceBoard.getClientRects()?.[0];
  let buttonBbox = button?.getClientRects()?.[0];
  if (sourceBbox && buttonBbox) {
    let sx1 = sourceBbox.x;
    let sx2 = sourceBbox.x + sourceBbox.width;
    let sxa = Math.min(50, sourceBbox.width * 0.1);
    let sy1 = sourceBbox.y;
    let sy2 = sourceBbox.y + sourceBbox.height;
    let sya = Math.min(50, sourceBbox.height * 0.1);
    let source8pos = [
      [sx1 + sxa, sy1], // top, left
      [(sx1 + sx2) / 2, sy1], // top, center
      [sx2 - sxa, sy1], // top, right
      [sx2, sy1 + sya], // right, top
      [sx2, (sy1 + sy2) / 2], // right, middle
      [sx2, sy2 - sya], // right, bottom
      [sx2 - sxa, sy2], // bottom, right
      [(sx1 + sx2) / 2, sy2], // bottom, center
      [sx1 + sxa, sy2], // bottom, left
      [sx1, sy2 - sya], // left, bottom
      [sx1, (sy1 + sy2) / 2], // left, middle
      [sx1, sy1 + sya], // left, top
    ];
    let buttonRefPoint = [buttonBbox.x + buttonBbox.width / 2, buttonBbox.y];
    let closestSourcePoint = [],
      min = Infinity;
    source8pos.forEach((pos) => {
      let val = Math.sqrt(
        Math.pow(buttonRefPoint[0] - pos[0], 2) +
        Math.pow(buttonRefPoint[1] - pos[1], 2)
      );
      if (val < min) {
        closestSourcePoint = pos;
        min = val;
      }
    });
    let calloutPosition = [
      Math.min(buttonRefPoint[0], closestSourcePoint[0]),
      Math.min(buttonRefPoint[1], closestSourcePoint[1]),
    ];
    let calloutSize = [
      Math.abs(buttonRefPoint[0] - closestSourcePoint[0]),
      Math.abs(buttonRefPoint[1] - closestSourcePoint[1]),
    ];
    let direction =
      (buttonRefPoint[0] > closestSourcePoint[0] ? "l" : "r") +
      (buttonRefPoint[1] > closestSourcePoint[1] ? "t" : "b");
    let calloutWrap = d3.select("#view-column").append("div");
    calloutWrap
      .attr("id", "source-callout")
      .style("z-index", 0)
      .style("position", "fixed")
      .style("left", calloutPosition[0] - 10 + "px")
      .style("top", calloutPosition[1] + 35 + "px")
      .style("width", calloutSize[0] + 20 + "px")
      .style("height", calloutSize[1] + "px");
    let callout = calloutWrap.append("svg");
    callout
      .attr("width", calloutSize[0] + 20 + "px")
      .attr("height", calloutSize[1] + "px");
    let path = "";
    if (direction === "lt") {
      path += `M 10 5 C 10 5, ${calloutSize[0] + 10} ${calloutSize[1] - 70
        }, ${calloutSize[0] + 10} ${calloutSize[1] - 5}`;
      callout
        .append("circle")
        .attr("cx", 10)
        .attr("cy", 5)
        .attr("r", 3)
        .attr("fill", "#999999");
      callout
        .append("circle")
        .attr("cx", calloutSize[0] + 10)
        .attr("cy", calloutSize[1] - 5)
        .attr("r", 3)
        .attr("fill", "#999999");
    } else if (direction === "rt") {
      path += `M ${calloutSize[0] + 10} 5 C ${calloutSize[0] + 10}  5,  10 ${calloutSize[1] - 70
        }, 10 ${calloutSize[1] - 5}`;
      callout
        .append("circle")
        .attr("cx", calloutSize[0] + 10)
        .attr("cy", 5)
        .attr("r", 3)
        .attr("fill", "#999999");
      callout
        .append("circle")
        .attr("cx", 10)
        .attr("cy", calloutSize[1] - 5)
        .attr("r", 3)
        .attr("fill", "#999999");
    } else if (direction === "lb") {
      calloutWrap
        .style("top", calloutPosition[1] - 25 + "px") // -35
        .style("height", calloutSize[1] + 35 + "px"); // +35
      callout.attr("height", calloutSize[1] + 35 + "px");
      path += `M 10 ${calloutSize[1] + 30} C 10 ${calloutSize[1] + 30}, ${calloutSize[0] - 40
        } -20, ${calloutSize[0] + 10} 25`;
      callout
        .append("circle")
        .attr("cx", 10)
        .attr("cy", calloutSize[1] + 30)
        .attr("r", 3)
        .attr("fill", "#999999");
      callout
        .append("circle")
        .attr("cx", calloutSize[0] + 10)
        .attr("cy", 25)
        .attr("r", 3)
        .attr("fill", "#999999");
    } else if (direction === "rb") {
      calloutWrap
        .style("top", calloutPosition[1] - 25 + "px") // -35
        .style("height", calloutSize[1] + 35 + "px"); // +35
      callout.attr("height", calloutSize[1] + 35 + "px");
      path += `M ${calloutSize[0] + 10} ${calloutSize[1] + 30} C ${calloutSize[0] + 10
        } ${calloutSize[1] + 30}, 50 -20, 10 25`;
      callout
        .append("circle")
        .attr("cx", calloutSize[0] + 10)
        .attr("cy", calloutSize[1] + 30)
        .attr("r", 3)
        .attr("fill", "#999999");
      callout
        .append("circle")
        .attr("cx", 10)
        .attr("cy", 25)
        .attr("r", 3)
        .attr("fill", "#999999");
    }
    callout
      .append("path")
      .attr("d", path)
      .attr("fill", "transparent")
      .attr("stroke", "#999999")
      .attr("stroke-width", "3");
  }
}

export function unmarkSourceView(uid) {
  document.querySelector("#source-callout")?.remove();
}

export function setActive(u) {
  if (get(activeSpec) !== u && get(unlockedSpecs).includes(u)) {
    document
      .querySelectorAll(`#view-${get(activeSpec)} *.dupo-g-found`)
      .forEach((elem) => elem?.classList.remove("dupo-g-found"));
    activeSpec.set(u);
    updateActiveSpec(u);
    systemLog.update((log) => {
      log.log({ message: "Activate an artboard", artboard_uid: u });
      return log;
    });
  }
}